import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { postProdutoInEquipamento } from '../../../slices/productSlice.js';
import { useEquipament } from '../../../hook/useEquipament.js';
import Equipamentos from '../../../components/ArvorePecas/Equipamentos.jsx';
import Main from '../../../components/Main/Main';
import Title from '../../../components/Title.jsx';
import Form from '../../../components/Main/Form.jsx';
import { useForm } from 'react-hook-form';
import ButtonDinamic from '../../../components/ButtonDinamic.jsx';
import { Typography, IconButton, Tooltip } from '@material-tailwind/react';
import { SquarePlus } from 'lucide-react';
import { AddModalInputs } from '../../../components/Modal/AddModalInputs.jsx';
import usePageTitle from '../../../hook/usePageTitle.js';

const PecaEnEquipamento = () => {
  const dispatch = useDispatch();
  usePageTitle();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    watch,
    getValues,
    formState: { errors },
  } = useForm();
  const { result, pathsCall } = useEquipament();
  const watchTag = watch('tag');

  const onSubmit = (data) => {
    const newData = { ...data, maquinario: id };
    dispatch(postProdutoInEquipamento(newData));
  };

  const [open, setOpen] = useState(0);
  const [modal, setModal] = useState(false);
  const handleOpen = (value) => setOpen(open === value ? 0 : value);
  const handleModel = () => {
    setModal(!modal);
  };

  const handlKeyEnter = (event) => {
    if (event.key == 'Enter') {
      handleTag();
    }
  };

  const handleTag = () => {
    const tag = getValues('tag');
    pathsCall(tag.toLowerCase());
  };

  useEffect(() => {
    if (result.error) {
      setError('tag', { type: 'manual', message: 'Tag incorreta' });
    } else {
      clearErrors();
    }
  }, [result]);

  return (
    <Main>
      <Title>Cadastrar equipamento em maquinario </Title>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-[90%] sm:flex sm:flex-wrap gap-3 ">
          <ButtonDinamic
            formCamp="tag"
            type="text"
            label="Tag"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.tag ? errors : false}
            valor={watchTag}
            onBlur={() => handleTag()}
            onKeyDown={handlKeyEnter}
          />
          <ButtonDinamic
            formCamp="nome"
            type="text"
            label="Nome"
            register={register}
            required={true}
            errors={errors?.nome ? errors : false}
            disabled={true}
            valor={result.nome || null}
          />
          <ButtonDinamic
            formCamp="linha"
            type="text"
            label="Linha"
            register={register}
            disabled={true}
            required={true}
            errors={errors?.linha ? errors : false}
            valor={result.linha || null}
          />
        </div>
        <hr className="my-2 border-gray-400  shadow-black  h-1 w-[80%]" />
        <div>
          <Typography className="font-bold text-xl text-black dark:text-white ">
            Equipamento
            {result?.id && (
              <Tooltip content="Adicionar ">
                <IconButton variant="text" onClick={handleModel}>
                  <SquarePlus className="dark:opacity-60 dark:text-white text-darkText" />
                </IconButton>
              </Tooltip>
            )}
          </Typography>
        </div>
        {!result.error && result?.id && <Equipamentos maquinarioId={result?.id} />}
      </Form>
      <AddModalInputs modal={modal} handleModal={handleModel} id={result?.id} />
    </Main>
  );
};

export default PecaEnEquipamento;
